import React from 'react';

import SearchableMenu from 'components/base/Menu/SearchableMenu';
import { Button, ListItem, ListLabel } from './shared/components';

interface IDropdownProps {
  // objects with (for instance) labels and values
  items: Record<string, unknown>[];
  // currently active item
  selectedItem: Record<string, unknown>;
  // callback when item changes
  onChange: Function;
  // disables the dropdown when true
  disabled: boolean;
  // overflows the dropdown to the left when true
  overflowLeft?: boolean;
  // color scale for compare mode
  entityColorScale?: Function;
  // callback to retrieve data string from the item object
  itemToString?: Function;
  // button is green
  isActiveGreen?: boolean;
  // new design for buttons and dropdowns
  isRoundedDropdown?: string;
  Item?: any;
  selectedItems?: any;
  multipleSelections?: any;
  isMultipleSelection?: boolean;
}

const SearchableDropdown: React.FC<IDropdownProps> = (props) => {
  const {
    items,
    selectedItem,
    selectedItems,
    multipleSelections,
    onChange,
    disabled,
    overflowLeft,
    entityColorScale,
    itemToString,
    isActiveGreen = true,
    isRoundedDropdown,
    Item,
    isMultipleSelection,
  } = props;

  return (
    <SearchableMenu
      items={items}
      selectedItem={selectedItem}
      selectedItems={selectedItems}
      multipleSelections={multipleSelections}
      onChange={onChange}
      disabled={disabled}
      Button={Button}
      Item={Item || ListItem}
      ListLabel={ListLabel}
      overflowLeft={overflowLeft}
      entityColorScale={entityColorScale}
      itemToString={itemToString}
      isActiveGreen={isActiveGreen}
      isRoundedDropdown={isRoundedDropdown}
      isMultipleSelection={isMultipleSelection}
    />
  );
};

export default SearchableDropdown;
